module.exports = __webpack_public_path__ + "media/images/forms-icons/temprature-icon-26591c7ec498b3cf472a0133e5d63965.svg";